import PlatformAdvancedForm from './PlatformAdvancedForm'

export default PlatformAdvancedForm
